export default "__VITE_ASSET__ClCNmAY4__"